import type { StoryTrailConfig } from '../minigames/StoryTrailConfig.js';

export const SILENT_STORY_TREE_TRAIL: StoryTrailConfig = {
  id: 'story-tree-sequence-1',
  skillId: 'literacy-story-sequence',
  title: 'The Paper Bird\'s Seed',
  passage: [
    'Cosmo heard a paper bird rustling beside the silent Story Tree.',
    'He followed it to the stream, where it dropped a glowing seed.',
    'Cosmo planted the seed by the tree, and a new story light began to shine.',
  ].join(' '),
  events: [
    { id: 'hear-bird', text: 'Cosmo hears a paper bird by the Story Tree.' },
    { id: 'find-seed', text: 'The bird drops a glowing seed near the stream.' },
    { id: 'plant-seed', text: 'Cosmo plants the seed, and a story light shines.' },
  ],
  correctOrder: ['hear-bird', 'find-seed', 'plant-seed'],
  rewardEvent: 'story-lantern-1',
  hint: 'Think about what Cosmo noticed first, what he found next, and what he did last.',
  successMessage: 'The first Story Lantern is shining again!',
};
